const ASM_DATABASE = [
  { generic: "Levetiracetam", brands: ["Keppra", "Spritam"], doseRange: "500–3000 mg/day", teratogenic: false, monitoring: false },
  { generic: "Lamotrigine", brands: ["Lamictal"], doseRange: "100–600 mg/day", teratogenic: false, monitoring: false },
  { generic: "Valproic acid / Valproate", brands: ["Depakote", "Depakene", "Epilim"], doseRange: "500–3000 mg/day", teratogenic: true, monitoring: true },
  { generic: "Carbamazepine", brands: ["Tegretol", "Carbatrol"], doseRange: "400–1600 mg/day", teratogenic: true, monitoring: true },
  { generic: "Oxcarbazepine", brands: ["Trileptal", "Oxtellar XR"], doseRange: "600–2400 mg/day", teratogenic: false, monitoring: true },
  { generic: "Topiramate", brands: ["Topamax", "Qudexy XR"], doseRange: "100–400 mg/day", teratogenic: true, monitoring: false },
  { generic: "Zonisamide", brands: ["Zonegran"], doseRange: "100–600 mg/day", teratogenic: false, monitoring: false },
  { generic: "Lacosamide", brands: ["Vimpat"], doseRange: "100–400 mg/day", teratogenic: false, monitoring: false },
  { generic: "Brivaracetam", brands: ["Briviact"], doseRange: "50–200 mg/day", teratogenic: false, monitoring: false },
  { generic: "Clobazam", brands: ["Onfi", "Sympazan"], doseRange: "5–40 mg/day", teratogenic: false, monitoring: false },
  { generic: "Perampanel", brands: ["Fycompa"], doseRange: "2–12 mg/day", teratogenic: false, monitoring: false },
  { generic: "Eslicarbazepine", brands: ["Aptiom"], doseRange: "400–1600 mg/day", teratogenic: false, monitoring: true },
  { generic: "Cenobamate", brands: ["Xcopri"], doseRange: "100–400 mg/day", teratogenic: false, monitoring: false },
  { generic: "Phenytoin", brands: ["Dilantin", "Phenytek"], doseRange: "200–600 mg/day", teratogenic: true, monitoring: true },
  { generic: "Phenobarbital", brands: ["Luminal"], doseRange: "60–240 mg/day", teratogenic: true, monitoring: true },
  { generic: "Primidone", brands: ["Mysoline"], doseRange: "250–1500 mg/day", teratogenic: true, monitoring: true },
  { generic: "Ethosuximide", brands: ["Zarontin"], doseRange: "500–1500 mg/day", teratogenic: false, monitoring: true },
  { generic: "Gabapentin", brands: ["Neurontin", "Gralise"], doseRange: "900–3600 mg/day", teratogenic: false, monitoring: false },
  { generic: "Pregabalin", brands: ["Lyrica"], doseRange: "150–600 mg/day", teratogenic: false, monitoring: false },
  { generic: "Tiagabine", brands: ["Gabitril"], doseRange: "4–56 mg/day", teratogenic: false, monitoring: false },
  { generic: "Vigabatrin", brands: ["Sabril"], doseRange: "1000–3000 mg/day", teratogenic: false, monitoring: true },
  { generic: "Felbamate", brands: ["Felbatol"], doseRange: "1200–3600 mg/day", teratogenic: false, monitoring: true },
  { generic: "Rufinamide", brands: ["Banzel"], doseRange: "400–3200 mg/day", teratogenic: false, monitoring: false },
  { generic: "Stiripentol", brands: ["Diacomit"], doseRange: "50 mg/kg/day", teratogenic: false, monitoring: false },
  { generic: "Cannabidiol", brands: ["Epidiolex"], doseRange: "5–20 mg/kg/day", teratogenic: false, monitoring: true },
  { generic: "Fenfluramine", brands: ["Fintepla"], doseRange: "0.2–0.7 mg/kg/day", teratogenic: false, monitoring: true },
  { generic: "Clonazepam", brands: ["Klonopin"], doseRange: "0.5–20 mg/day", teratogenic: false, monitoring: false },
  { generic: "Diazepam", brands: ["Valium", "Valtoco"], doseRange: "2–40 mg/day", teratogenic: false, monitoring: false },
  { generic: "Lorazepam", brands: ["Ativan"], doseRange: "1–10 mg/day", teratogenic: false, monitoring: false },
  { generic: "Midazolam", brands: ["Nayzilam"], doseRange: "Rescue dosing", teratogenic: false, monitoring: false },
  { generic: "Acetazolamide", brands: ["Diamox"], doseRange: "250–1000 mg/day", teratogenic: false, monitoring: false },
  { generic: "Everolimus", brands: ["Afinitor"], doseRange: "Varies", teratogenic: true, monitoring: true },
  { generic: "ACTH / Corticotropin", brands: ["Acthar", "H.P. Acthar"], doseRange: "Varies", teratogenic: false, monitoring: true }
];

const DISCONTINUATION_REASONS = [
  "Ineffective (no seizure reduction)",
  "Partial response only",
  "Breakthrough seizures",
  "Side effects — drowsiness/fatigue",
  "Side effects — cognitive (memory, concentration)",
  "Side effects — mood changes / irritability",
  "Side effects — weight gain",
  "Side effects — weight loss",
  "Side effects — dizziness / ataxia",
  "Side effects — rash",
  "Side effects — hair loss",
  "Side effects — tremor",
  "Side effects — GI symptoms",
  "Side effects — vision problems",
  "Allergic reaction",
  "Drug–drug interaction",
  "Pregnancy planning / teratogenicity risk",
  "Insurance / cost issues",
  "Patient preference",
  "Planned medication consolidation",
  "Seizure freedom — weaning trial",
  "Replaced by newer agent",
  "Other (specify in notes)"
];

export { ASM_DATABASE, DISCONTINUATION_REASONS };
